import styled from "styled-components";
import { css } from "@emotion/react";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
`;
